import { render, staticRenderFns } from "./register-status.vue?vue&type=template&id=8dc955c0&scoped=true&"
import script from "./register-status.vue?vue&type=script&lang=ts&"
export * from "./register-status.vue?vue&type=script&lang=ts&"
import style0 from "./register-status.vue?vue&type=style&index=0&id=8dc955c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc955c0",
  null
  
)

export default component.exports